// general
export const serverError = 'generic.server_error'
